import { useEffect, useState } from 'react';

type ModuleTypes = 'fun-mission' | 'race' | 'casinoTournament';

export const useIsModuleLoaded = (module: ModuleTypes): boolean => {
  const [isLoaded, setIsLoaded] = useState(false);

  const setupProxy = (): void => {
    const gdlib = window.__gdlib;
    const moduleSdk = gdlib?.[`${module}_module`];

    if (moduleSdk?.hasOwnProperty('setupFinished')) {
      setIsLoaded(true);
      return;
    }

    const interval: any = setInterval(() => {
      if (moduleSdk?.hasOwnProperty('setupFinished')) {
        setIsLoaded(true);
        return clearInterval(interval);
      }
    }, 100);
  };

  useEffect(() => {
    setupProxy();
  }, []);

  return isLoaded;
};
